// PRD-1358 — reconciling the open details modal against a refreshed list.
//
// The Data Sources page keeps the clicked dataset in `selectedDataset`, which is
// a SNAPSHOT of the object as it was when the card was clicked. Polling replaces
// the `datasets` array wholesale, so without re-deriving, a dataset that settles
// into review-required — or has one of its parked files reviewed — while its
// modal is open keeps rendering whatever was true on open. That was the headline
// symptom in PRD-1358.
//
// Extracted so the behaviour is testable: the effect that calls it cannot be
// unit-tested without a full Data Sources harness, and this is the part with the
// actual decisions in it.

/**
 * Pick the version of the selected dataset to render, given a refreshed list.
 *
 * @param {object|null} current the currently selected dataset, or null
 * @param {Array<object>} datasets the freshly loaded list
 * @returns {object|null} the refreshed dataset when the list still holds it,
 *   otherwise `current` UNCHANGED (same reference, so React bails out of the
 *   re-render rather than churning the modal every poll).
 *
 * Keeping `current` when the dataset is absent is deliberate. A filter change, a
 * page change, or a dataset dropping out of the current query would otherwise
 * clear the selection and close the modal out from under the reviewer — worse
 * than briefly showing stale counts. Closing on absence would also fight the
 * status filter: reviewing the last parked file removes the dataset from the
 * "Review Required" list, and the reviewer would lose the modal mid-task.
 */
export function reconcileSelectedDataset(current, datasets) {
  if (!current) return current;
  const fresh = (datasets || []).find((d) => d.id === current.id);
  return fresh || current;
}

export default reconcileSelectedDataset;
